/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ChangeEvent, useEffect, useState } from 'react';

interface UseInputProps {
  initialValue?: string;
  onChange?: () => void;
  isRequired?: boolean;
  requiredErrorKey?: string;
  validate?: (value: string) => boolean;
  validateErrorKey?: string;
  initialDisabled?: boolean;
}

const isEmpty = (val?: string) => !val || val.length === 0;

export const useInput = ({
  initialValue,
  onChange,
  isRequired = true,
  requiredErrorKey = 'thisFieldIsRequired',
  validate,
  validateErrorKey = 'thisFieldDoesntRespectFormat',
  initialDisabled = false,
}: UseInputProps = {}) => {
  const [value, setValue] = useState(initialValue);
  const [isValid, setIsValid] = useState(!isRequired);
  const [disabled, setDisabled] = useState(initialDisabled);
  const [error, setError] = useState<string>(
    isRequired ? requiredErrorKey : '',
  );

  function handleChange(
    event: ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
  ) {
    setValue(event.target.value);
    onChange && onChange();
  }

  useEffect(() => {
    if (isRequired && isEmpty(value)) {
      setError(requiredErrorKey);
      setIsValid(false);
      return;
    }

    if (value && validate !== undefined && !validate(value)) {
      setError(validateErrorKey);
      setIsValid(false);
      return;
    }

    setError('');
    setIsValid(true);
  }, [value]);

  return {
    value,
    setValue,
    onChange: handleChange,
    isValid,
    error,
    disabled,
    setDisabled,
  };
};
